import React, { useEffect } from "react";
import withIntl from "../../utils/withIntl";
import SearchForms from "../Forms/SearchForms";
import articlesStore from "../../store/articles/ArticlesStore";
import { getArticles } from "../../store/articles/ArticlesApi";
import cloudStore from "../../store/CloudStore";
import CircularProgress from "@material-ui/core/CircularProgress";

function SelectArticles(props) {
  const [articles, setArticles] = React.useState(articlesStore.articles);

  useEffect(() => {
    if (articles == null) {
      getArticles(cloudStore.merchant.id);
    }
  }, []);

  function onChangeArticles() {
    setArticles(articlesStore.articles);
  }

  useEffect(() => {
    articlesStore.on(articlesStore.events.ARTICLES_UPDATED, onChangeArticles);
    return () => {
      articlesStore.removeListener(articlesStore.events.ARTICLES_UPDATED, onChangeArticles);
    };
  }, []);

  if (articles == null) {
    return (
      <div align="center">
        <CircularProgress size={18} color="primary" />
      </div>
    );
  }

  let allResults = Object.keys(articles).map((key) => {
    return {
      plu: articlesStore.articles[key].plu,
      name: `${articlesStore.articles[key].name} - plu: ${articlesStore.articles[key].plu}`,
      id: articlesStore.articles[key].id,
    };
  });

  if (props.filteredOutArticles != null) {
    allResults = allResults.filter(
      (article) => !props.filteredOutArticles.some((articleId) => articleId === article.id)
    );
  }

  return (
    <SearchForms
      variant={"outlined"}
      InputProps={props.InputProps}
      key={props.article}
      helperText={props.helpertext ?? ""}
      valueVisibleAsLabel
      label={props.label ?? props.intl.formatMessage({ id: "select_article" }) + ": "}
      allResults={allResults}
      value={articles[props.articleId]?.name ?? props.value ?? ""}
      handleSelect={(option) => props.handleOnSelect(option)}
    />
  );
}

export default withIntl(SelectArticles);
